
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/new_audioknigi/sorting/visited",
      function () {
        return require("private-next-pages/new_audioknigi/sorting/visited/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/new_audioknigi/sorting/visited"])
      });
    }
  